import { render, staticRenderFns } from "./DropdownResponse.vue?vue&type=template&id=630b81b0&scoped=true&"
import script from "./DropdownResponse.vue?vue&type=script&lang=ts&"
export * from "./DropdownResponse.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownResponse.vue?vue&type=style&index=0&id=630b81b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630b81b0",
  null
  
)

export default component.exports